<template>
  <div>
    <header class="rh-top">
      <img :src="logo" alt="MetaVirtue" class="rh-top-logo" />
      <nav class="rh-nav" aria-label="Módulos MetaVirtue">
        <router-link to="/rh" :class="{ active: pagina === 'inicio' }">Início</router-link>
        <router-link to="/rh/diagnostico" :class="{ active: pagina === 'diagnostico' }">Diagnóstico</router-link>
        <router-link to="/rh/desenvolvimento" :class="{ active: pagina === 'desenvolvimento' }"
          >Desenvolvimento</router-link
        >
        <router-link v-if="podeVerAgenda" to="/rh/agenda" :class="{ active: pagina === 'agenda' }"
          >Agenda</router-link
        >
        <b-dropdown
          v-if="podeMostrarEstrutura || podeMostrarConfiguracao || podeMostrarPessoas"
          class="rh-nav-dropdown"
          position="is-bottom-left"
          aria-role="menu"
          :mobile-modal="false"
          :trigger-tabindex="-1"
        >
          <template #trigger="{ active }">
            <button
              type="button"
              class="rh-nav-dropdown-trigger"
              :class="{ active: pagina === 'estrutura' || pagina === 'configuracao' || pagina === 'pessoas' }"
              :aria-expanded="active ? 'true' : 'false'"
              aria-label="Abrir menu Cadastros"
            >
              Cadastros <b-icon :icon="active ? 'menu-up' : 'menu-down'" size="is-small" />
            </button>
          </template>
          <b-dropdown-item v-if="podeMostrarEstrutura" has-link aria-role="menuitem">
            <router-link to="/rh/estrutura" :class="{ active: pagina === 'estrutura' }">Estrutura</router-link>
          </b-dropdown-item>
          <b-dropdown-item v-if="podeMostrarConfiguracao" has-link aria-role="menuitem">
            <router-link to="/rh/configuracao" :class="{ active: pagina === 'configuracao' }"
              >Configurações</router-link
            >
          </b-dropdown-item>
          <b-dropdown-item v-if="podeMostrarPessoas" has-link aria-role="menuitem">
            <router-link to="/rh/pessoas" :class="{ active: pagina === 'pessoas' }">Pessoas</router-link>
          </b-dropdown-item>
        </b-dropdown>
      </nav>
      <div class="rh-actions">
        <div v-if="config.logoffTimer" class="rh-idle-progress">
          <b-progress :value="idleProgressBarValue" :type="idleProgressBarType" show-value>
            <small>{{ idleRemainingTime }}</small>
          </b-progress>
        </div>
        <button class="rh-icon-button" type="button" title="Notificações recebidas" aria-label="Notificações recebidas" @click="modalNotificacaoIsOpened = true">
          <b-icon icon="bell" />
          <b-tag v-if="totalNotificacao > 0" type="is-danger" rounded class="rh-notification-count">{{ totalNotificacao }}</b-tag>
        </button>
        <button
          class="rh-icon-button"
          :class="{ 'rh-avatar-button': fotoUrl }"
          type="button"
          :title="nomeUsuario ? `${nomeUsuario} · ${unidadeNome}` : 'Editar perfil'"
          aria-label="Editar perfil"
          @click="modalUsuarioIsOpened = true"
        >
          <img v-if="fotoUrl" :src="fotoUrl" alt="" class="rh-avatar" />
          <b-icon v-else icon="account" />
        </button>
      </div>
    </header>
    <b-modal :active="modalNotificacaoIsOpened" @update:active="modalNotificacaoIsOpened = $event" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <modal-notificacao @close="modalNotificacaoIsOpened = false" />
    </b-modal>
    <b-modal :active="modalUsuarioIsOpened" @update:active="atualizarModalUsuario" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <modal-usuario
        :descricao-vinculo="descricaoVinculo"
        :descricao-vinculo-completa="descricaoVinculoCompleta"
        :unidade-id="unidadeId"
        :empresas="empresas"
        @empresa-selecionada="selecionarEmpresa"
        @foto-alterada="carregarFoto"
        @close="atualizarModalUsuario(false)"
      />
    </b-modal>
    <div v-if="mostrarApresentacao" class="rh-heading">
      <div>
        <p class="rh-kicker">{{ subtitulo }}</p>
        <h1>{{ titulo }}</h1>
        <p>{{ descricao }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import logo from '@/assets/rh_logo.png'
import ModalNotificacao from '@/components/modalNotificacao.vue'
import ModalUsuario from '@/components/modalUsuario.vue'
import http from '@/http'
import { mapGetters } from 'vuex'

export default {
  name: 'RhCabecalho',
  components: { ModalNotificacao, ModalUsuario },
  data() {
    return { logo, fotoUrl: null, descricaoVinculo: '', descricaoVinculoCompleta: '', requisicaoVinculo: 0 }
  },
  computed: {
    ...mapGetters(['isInRole']),
    usuario() {
      return this.$store.state.usuario || {}
    },
    nomeUsuario() {
      return String(this.usuario.apelido || this.usuario.nome || '').trim()
    },
    unidadeNome() {
      const empresa = this.empresas.find((item) => item.id === this.unidadeId)
      return empresa ? empresa.nome : 'Nenhuma selecionada'
    },
    config() {
      return this.$store.state.config
    },
    idleRemainingTime() {
      const totalSeconds = Math.max(0, (this.config.logoffMiliseconds - this.$store.state.idle.time) / 1000)
      const minutes = Math.floor(totalSeconds / 60)
      const seconds = Math.floor(totalSeconds % 60)
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    },
    idleProgressBarValue() {
      const value = ((this.config.logoffMiliseconds - this.$store.state.idle.time) / this.config.logoffMiliseconds) * 100
      return isNaN(value) ? 100 : value
    },
    idleProgressBarType() {
      return this.idleProgressBarValue > 66 ? 'is-info' : this.idleProgressBarValue > 33 ? 'is-warning' : 'is-danger'
    },
    totalNotificacao() {
      return this.$store.state.componentes.totalNotificacao
    },
    modalNotificacaoIsOpened: {
      get() {
        return this.$store.state.componentes.modalNotificacaoIsOpened
      },
      set(value) {
        this.$store.commit('componentes/SET_MODAL_NOTIFICACAO', value)
      },
    },
    modalUsuarioIsOpened: {
      get() {
        return this.$store.state.componentes.modalUsuarioIsOpened
      },
      set(value) {
        this.$store.commit('componentes/SET_MODAL_USUARIO', value)
      },
    },
    podeVerAgenda() {
      return this.isInRole('rh-diretoria') || this.isInRole('rh-lider')
    },
    podeMostrarEstrutura() {
      return this.isInRole('rh-diretoria') || this.isInRole('rh-lider')
    },
    podeMostrarPessoas() {
      return this.mostrarPessoas && this.podeVerAgenda
    },
    podeMostrarConfiguracao() {
      return this.mostrarConfiguracao && this.isInRole('rh-diretoria')
    },
  },
  props: {
    pagina: { type: String, required: true },
    subtitulo: { type: String, default: '' },
    titulo: { type: String, default: '' },
    descricao: { type: String, default: '' },
    mostrarApresentacao: { type: Boolean, default: true },
    rotuloDiagnostico: { type: String, default: 'Diagnóstico' },
    unidadeId: { type: Number, default: null },
    empresas: { type: Array, required: true },
    mostrarPessoas: { type: Boolean, default: false },
    mostrarConfiguracao: { type: Boolean, default: false },
  },
  mounted() {
    this.carregarTotais()
    this.carregarFoto()
    this.carregarVinculo()
  },
  beforeDestroy() {
    this.requisicaoVinculo++
    if (this.fotoUrl) URL.revokeObjectURL(this.fotoUrl)
  },
  watch: {
    unidadeId() {
      this.carregarVinculo()
    },
  },
  methods: {
    async carregarVinculo() {
      const requisicao = ++this.requisicaoVinculo
      const unidadeId = this.unidadeId
      this.descricaoVinculo = this.isInRole('rh-diretoria') ? 'Diretoria' : 'Sem equipe definida'
      this.descricaoVinculoCompleta = this.descricaoVinculo
      if (!unidadeId) return
      try {
        const { data } = await http.get('/api/rh/estrutura/meu-vinculo', { params: { unidadeId } })
        if (requisicao === this.requisicaoVinculo) {
          this.descricaoVinculo = data && typeof data.descricao === 'string' && data.descricao.trim()
            ? data.descricao.trim()
            : 'Sem equipe definida'
          this.descricaoVinculoCompleta = data && typeof data.descricaoCompleta === 'string' && data.descricaoCompleta.trim()
            ? data.descricaoCompleta.trim()
            : this.descricaoVinculo
        }
      } catch {
        if (requisicao === this.requisicaoVinculo) {
          this.descricaoVinculo = 'Sem equipe definida'
          this.descricaoVinculoCompleta = this.descricaoVinculo
        }
      }
    },
    atualizarModalUsuario(ativo) {
      this.modalUsuarioIsOpened = ativo
      if (!ativo) this.carregarFoto()
    },
    async carregarFoto() {
      try {
        const { data } = await http.get('/api/rh/estrutura/minha-foto', { responseType: 'blob' })
        const novaUrl = data && data.size ? URL.createObjectURL(data) : null
        if (this.fotoUrl) URL.revokeObjectURL(this.fotoUrl)
        this.fotoUrl = novaUrl
      } catch {
        if (this.fotoUrl) URL.revokeObjectURL(this.fotoUrl)
        this.fotoUrl = null
      }
    },
    selecionarEmpresa(id) {
      this.$store.commit('SET_UNIDADE', id)
      this.$emit('empresa-selecionada', id)
    },
    async carregarTotais() {
      try {
        const { data } = await http.get('/api/notificacao/RetornaTotaisUsuarioLogado')
        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO', data.notificacoes)
        this.$store.commit('componentes/SET_TOTAL_MENSAGENS', data.mensagens)
      } catch {
        this.$store.commit('componentes/SET_TOTAL_NOTIFICACAO', 0)
        this.$store.commit('componentes/SET_TOTAL_MENSAGENS', 0)
        this.$buefy.toast.open({ message: 'Não foi possível carregar as notificações recebidas.', type: 'is-danger' })
      }
    },
  },
}
</script>

<style scoped>
.rh-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 26px 4px;
}
.rh-top-logo {
  width: 205px;
  height: auto;
  flex: none;
}
.rh-nav {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 17px;
  flex-wrap: wrap;
  min-width: 0;
}
.rh-nav a {
  color: #53627b;
  font-size: 13px;
  font-weight: 700;
}
.rh-nav a.active {
  color: var(--blue);
  border-bottom: 2px solid var(--blue);
}
.rh-nav-dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 0;
  border: 0;
  border-bottom: 2px solid transparent;
  background: transparent;
  color: #53627b;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}
.rh-nav-dropdown-trigger:hover,
.rh-nav-dropdown-trigger:focus-visible,
.rh-nav-dropdown-trigger.active {
  color: var(--blue);
}
.rh-nav-dropdown-trigger.active {
  border-bottom-color: var(--blue);
}
.rh-nav-dropdown a.active {
  color: var(--blue);
  background: #eef5ff;
  border-bottom: 0;
}
.rh-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: none;
}
.rh-idle-progress {
  width: 150px;
  flex: none;
}
.rh-idle-progress .progress-wrapper {
  margin-bottom: 0;
}
.rh-icon-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border: 0;
  background: transparent;
  color: #53627b;
  cursor: pointer;
}
.rh-icon-button:hover,
.rh-icon-button:focus-visible {
  color: var(--blue);
}
.rh-avatar-button {
  padding: 0;
  border-radius: 50%;
}
.rh-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
}
.rh-avatar-button:hover .rh-avatar,
.rh-avatar-button:focus-visible .rh-avatar {
  box-shadow: 0 0 0 2px var(--blue);
}
.rh-notification-count {
  position: absolute;
  top: -2px;
  right: -4px;
  font-size: 10px;
}
.rh-heading {
  margin: 5px 0 26px;
}
.rh-heading h1 {
  font-size: clamp(26px, 3vw, 38px);
  color: var(--navy);
  font-weight: 800;
  margin: 5px 0;
}
.rh-heading p:last-child {
  color: #667085;
  font-size: 13px;
}
.rh-kicker {
  letter-spacing: 0.15em;
  font-size: 11px;
  font-weight: 800;
  color: var(--teal);
  margin: 0;
}
@media (max-width: 800px) {
  .rh-top {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 16px 12px;
    padding: 18px 0 20px;
  }
  .rh-top-logo {
    grid-column: 1;
    grid-row: 1;
    max-width: 100%;
  }
  .rh-actions {
    grid-column: 2;
    grid-row: 1;
    justify-self: end;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  .rh-idle-progress {
    width: 110px;
  }
  .rh-nav {
    grid-column: 1 / -1;
    grid-row: 2;
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 6px;
  }
  .rh-nav-dropdown {
    justify-content: center;
  }
  .rh-top .rh-nav > a,
  .rh-nav-dropdown-trigger {
    min-width: 0;
    padding: 9px 4px;
    text-align: center;
    white-space: nowrap;
    font-size: 12px;
  }
  .rh-nav-dropdown-trigger {
    width: 100%;
    justify-content: center;
  }
  .rh-heading {
    margin-top: 0;
  }
}
@media (max-width: 380px) {
  .rh-top-logo {
    width: 160px;
  }
  .rh-nav {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
</style>
